import { RouteProps, RedirectProps } from 'react-router';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
export const tuple = <T extends string[]> (...args: T) => args;
export const tupleNum = <T extends number[]> (...args: T) => args;

export type Dict<T> = {
	[ key: string ]: T;
};

export interface FluxStandardAction {
	type: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload?: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	error?: boolean | any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	meta?: any;
}
export interface Dependencies {
	func (value: string): string;
}

export type CommonTypeTuple = string | boolean | number | undefined;

export interface AppRouteType extends RouteProps {
	key: number;
	children?: AppRouteType[];
	to?: RedirectProps[ 'to' ];
	headerIconSet?: any;
	layout?: React.ComponentType<any> | any;
}

export interface CommonStyledComponentProps {
	isMobile: boolean;
	specificWidth?: any;
	isLAMF?: boolean;
}
export interface LAMFStyledComponentProps {
	isLAMF?: boolean;
}

export interface MobileShareModeProps {
	isMobileShare: boolean;
}

export interface ProfileViewType {
	pan: string;
	gender: string;
	name: string;
	primaryEmail: any;
	dob: any;
	address: string;
	pincode: number;
	cancelledChequeURL: any;
	bankAccountNumber: string;
	bankAccountType: string;
	ifscCode: string;
	occupation: any;
	incomeSlab: any;
	aadhar: string;
	nomineeName: string;
	relationship: string;
	signatureURL: any;
	panStatus: string;
	fatcaCompliant: boolean;
}

export enum FlashTypes {
    SUCCESS = 'success',
    ERROR = 'error',
	NONE = 'none'
}
export interface IFlashShower {
    type: FlashTypes,
    message: string
}

export interface ShareConfigType {
    message: string,
    shareUrl: string,
    onEmailOrSMSShare: any,
    mixpanelData: any,
    shareType?: string,
    flashMessage?: React.ReactElement,
    customHeader?: React.ReactElement,
    shareTitle?: any,
	sharePopupText?: string,
	shareItemDetails?: any,
	customWhatsappShare?: Function,
	showDownloadLink?: boolean,
	hideCopyLink?: boolean,
	onFileDownload?: Function}

export interface PremiumServiceType {
	serviceTitle: string,
    icon: string,
	type: string,
    url: string
}
export interface LearnBusinessType {
	videoTitle: string,
    icon: string,
	videoDesc?: string,
    videoSrc: string
}
